import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type LinkUserToEventMutationVariables = Types.Exact<{
  event_id: Types.Scalars['ID'];
  user_id: Types.Scalars['ID'];
}>;


export type LinkUserToEventMutation = { __typename?: 'Mutation', linkUserToEvent: Array<{ __typename?: 'EventLinkedUser', id: string }> };


export const LinkUserToEventDocument = gql`
    mutation LinkUserToEvent($event_id: ID!, $user_id: ID!) {
  linkUserToEvent(event_id: $event_id, user_id: $user_id) {
    id
  }
}
    `;
export type LinkUserToEventMutationFn = Apollo.MutationFunction<LinkUserToEventMutation, LinkUserToEventMutationVariables>;

/**
 * __useLinkUserToEventMutation__
 *
 * To run a mutation, you first call `useLinkUserToEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkUserToEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkUserToEventMutation, { data, loading, error }] = useLinkUserToEventMutation({
 *   variables: {
 *      event_id: // value for 'event_id'
 *      user_id: // value for 'user_id'
 *   },
 * });
 */
export function useLinkUserToEventMutation(baseOptions?: Apollo.MutationHookOptions<LinkUserToEventMutation, LinkUserToEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LinkUserToEventMutation, LinkUserToEventMutationVariables>(LinkUserToEventDocument, options);
      }
export type LinkUserToEventMutationHookResult = ReturnType<typeof useLinkUserToEventMutation>;
export type LinkUserToEventMutationResult = Apollo.MutationResult<LinkUserToEventMutation>;
export type LinkUserToEventMutationOptions = Apollo.BaseMutationOptions<LinkUserToEventMutation, LinkUserToEventMutationVariables>;